import React, { useState } from 'react'
import DateTimeClock from '../DateTimeClock/DateTimeClock';
import moment from "moment";
import { Translate } from "react-redux-i18n";
import LoadingIndicator from "../LoadingIndicator";
import { Button } from "@blueprintjs/core";

export default function BookingForm({ selected_date, saving_booking, saveBooking }) {
  const [clock, setClockState] = useState({
    start_date: undefined,
    end_date: undefined,
  });

  const onClockUpdate = ({ start_date, end_date }) => {
    setClockState({ start_date, end_date });
  }
  const handleSave = () => {
    if (!clock.start_date || !clock.end_date) return;
    saveBooking([moment(clock.start_date), moment(clock.end_date)]);
  }

  return (
    <div className="dialog-wrapper">
      <div className="booking-details-form">
        <DateTimeClock
          selected_date={selected_date}
          onUpdate={onClockUpdate}
        />
        <Button
          intent="primary"
          fill={true}
          disabled={saving_booking}
          onClick={handleSave}
          className="save-booking-cta">
          {!saving_booking && <Translate value="booking.save_booking" />}
          {saving_booking && <LoadingIndicator />}
        </Button>
      </div>
    </div>
  )
}
